import axios from '@/axios'

export default {
  fetchData(params){
    return axios.post(`/reports/order`, params)
  },
  export(params){
    return axios.post(`/reports/order/export`, params)
  }
}